import { render, staticRenderFns } from "./CompanyGroupForm.vue?vue&type=template&id=07a99180&scoped=true&"
import script from "./CompanyGroupForm.vue?vue&type=script&lang=js&"
export * from "./CompanyGroupForm.vue?vue&type=script&lang=js&"
import style0 from "./CompanyGroupForm.vue?vue&type=style&index=0&id=07a99180&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a99180",
  null
  
)

/* custom blocks */
import block0 from "./CompanyGroupForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports